import { forwardRef } from 'react';

import type { IconProps } from './types';

export const ChevronDown = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', ...props }, forwardedRef) => (
    <svg
      width="8"
      height="8"
      viewBox="0 0 1024 1024"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={forwardedRef}
    >
      <path
        d="M83.64 241.189c-24.841 1.903-46.63 13.589-61.766 31.167l-.099.119C8.242 288.178 0 308.773 0 331.294c0 27.432 12.228 52.01 31.534 68.577l.121.102 421.538 361.319c15.7 13.527 36.293 21.764 58.807 21.764s43.107-8.237 58.926-21.863l-.119.099 421.538-361.319c19.424-16.669 31.655-41.244 31.655-68.679 0-22.52-8.243-43.115-21.874-58.937l.099.119c-16.663-19.345-41.19-31.519-68.563-31.519-22.574 0-43.214 8.282-59.05 21.97l.116-.096-362.73 310.743-362.73-310.743c-15.723-13.603-36.369-21.888-58.951-21.888a92.2 92.2 0 0 0-6.984.265l.305-.02z"
        fill={color}
      />
    </svg>
  )
);

export default ChevronDown;
